import { render, staticRenderFns } from "./antiFraudResult.vue?vue&type=template&id=684d12ae&scoped=true"
import script from "./antiFraudResult.vue?vue&type=script&lang=js"
export * from "./antiFraudResult.vue?vue&type=script&lang=js"
import style0 from "./antiFraudResult.vue?vue&type=style&index=0&id=684d12ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684d12ae",
  null
  
)

export default component.exports